<template>
  <div class="pageBox">
    <div class="content">
      <div class="ListBox">
        <el-row class="appInfohBox">
          <el-col :span="24" class="appInfo">
            <div class="imgBox">
              <img class="img" :src="this.appDetail.appIcon" alt=""/>
            </div>
            <div>
              <p class="appName ellipsis"><span :ref='appDetail.appName'>{{ appDetail.appName }}</span></p>
              <p class="flex">应用状态：
                <span v-if="appDetail.freezeState == '1'">正常</span>
                <span v-else class="freezeType">
                  <span v-for="(type,index) in (appDetail.freezeType || '').split('、')" :key="index">{{ type }} </span>
                </span>
              </p>
            </div>
            <div class="border"></div>
            <div>
              <p class="ellipsis">包名：
                <span :ref='appDetail.appPackage'>{{ appDetail.appPackage }}</span>
              </p>
            </div>
          </el-col>
        </el-row>
        <el-row class="appInfohBox">
          <el-col :span="10">
            <el-input class="searchBtn" placeholder="输入链接名称快速搜索" clearable v-model.trim="linkName"
                      @keyup.enter.native="search()" @change="onEmpty()">
              <el-button class="fontSize18 searchIcon" slot="append" icon="el-icon-search" @click="search()"
                         :disabled="this.linkName==''"></el-button>
            </el-input>
            <div class="color-999 margin-t10 fontSize16">说明：目前仅小米支持创建公测、内测版本的链接</div>
          </el-col>
          <el-col :span="14" class="text-right">
            <created-button @onCreated="onCreatedLink()" value="创建链接"></created-button>
          </el-col>
        </el-row>
        <div style="min-height:500px">
          <el-table
              class="tableBox"
              stripe
              :data="tableData"
              style="width: 100%"
              :header-cell-style="{'text-align':'center'}"
              :cell-style="{'text-align':'center'}">
            <el-table-column type="index" label="序号" width="80"></el-table-column>
            <el-table-column label="链接名称" prop="linkName"></el-table-column>
            <el-table-column label="生效时间" width="100">
              <template slot-scope="scope">
                <p>{{ scope.row.activeTime| parseTime() }}</p>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" width="100">
              <template slot-scope="scope">
                <p>{{ scope.row.createTime| parseTime() }}</p>
              </template>
            </el-table-column>
            <el-table-column label="Deeplink" width="100">
              <template slot-scope="scope">
                <i v-if="scope.row.androidDeeplink" class="el-icon-circle-check"></i>
                <i v-else class="el-icon-circle-close"></i>
              </template>
            </el-table-column>
            <!--            <el-table-column label="归因参数" width="100">
                          <template slot-scope="scope">
                            <i v-if="scope.row.referrer" class="el-icon-circle-check"></i>
                            <i v-else class="el-icon-circle-close"></i>
                          </template>
                        </el-table-column>-->
            <el-table-column label="iOS跳转" width="100">
              <template slot-scope="scope">
                <i v-if="scope.row.iosUrl" class="el-icon-circle-check"></i>
                <i v-else class="el-icon-circle-close"></i>
              </template>
            </el-table-column>
            <el-table-column label="兜底页" width="100">
              <template slot-scope="scope">
                <i v-if="scope.row.apkUrl" class="el-icon-circle-check"></i>
                <i v-else class="el-icon-circle-close"></i>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="100">
              <template slot-scope="scope">
                <p v-if="scope.row.showState==1">已冻结</p>
                <p v-if="scope.row.showState==2">已关闭</p>
                <p v-if="scope.row.showState==3">审核未通过</p>
                <p v-if="scope.row.showState==4">待审核</p>
                <p v-if="scope.row.showState==5">生效中</p>
                <p v-if="scope.row.showState==6">主动撤回</p>
              </template>
            </el-table-column>
            <el-table-column label="链接" width="150">
              <template slot-scope="scope">
                <div v-if="scope.row.linkUrl">
                  <span>{{ scope.row.linkUrl }}</span>
                  <i class="el-icon-document-copy cursor" @click="onCopy(scope.row.linkUrl)"></i>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="二维码" width="100">
              <template slot-scope="scope">
                <QRCode-dialog ref="QRCodeDialog"></QRCode-dialog>
                <el-button type="text" v-if="[3,4,6].indexOf(scope.row.showState) === -1"
                           @click="onQRCode(appDetail,scope.row)">下载
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="250">
              <template slot-scope="scope">
                <router-link class="margin-r10"
                             :to="{path:'/console/appLink/link/info',query:{id:scope.row.id,appName:appDetail.appName,}}">
                  <el-button type="text">详情</el-button>
                </router-link>
                <el-button v-if="scope.row.showState==4" type="text"
                           @click="revokeLink(scope.row.linkName,scope.row.id)">撤回
                </el-button>
                <el-button v-if="scope.row.showState==2" type="text" @click="openLink(scope.row.linkName,scope.row.id)">
                  开启
                </el-button>
                <el-button v-if="scope.row.showState==5" type="text"
                           @click="closeLink(scope.row.linkName,scope.row.id)">关闭
                </el-button>
                <el-button v-if="[3,6].indexOf(scope.row.showState) !== -1" type="text" @click="editLink(scope.row.id)">编辑</el-button>
                <el-button v-if="scope.row.showState==3" type="text" @click="onShowError(scope.row)">
                  原因
                </el-button>
                <el-button type="text" v-if="[3,4,6].indexOf(scope.row.showState) === -1"
                           @click="onLinkData(scope.row.id,scope.row.appId)">
                  数据
                </el-button>
                <el-button v-if="scope.row.showState==1" type="text" @click="onFreezeShow(scope.row.id)">
                  冻结原因
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="修改参数" width="120">
              <template slot-scope="scope">
                <el-button v-if="[3,4,6].indexOf(scope.row.showState) === -1 && !scope.row.versionCode"
                           type="text" @click="onModifyParamList(scope.row.linkName,scope.row.showState,scope.row.id)">
                  修改参数
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="margin-t30 text-right" v-if="total>0">
          <el-pagination
              class="paginationBox"
              background
              @size-change="sizeChange"
              @current-change="currentChange"
              :current-page.sync="page"
              :page-sizes="[10,20,50,100]"
              :page-size="perPage"
              :total="total"
              layout="total, prev, pager, next, sizes">
          </el-pagination>
        </div>
      </div>
      <freezeReason ref="freezeReason"></freezeReason>
    </div>
  </div>
</template>

<script>
import QRCodeDialog from "./template/QRCodeDialog";
import freezeReason from "./dialog/freezeReason.vue";

export default {
  components: {
    QRCodeDialog, freezeReason,
  },
  data() {
    return {
      isShowTooltipAppName: true,
      isShowTooltipAppPackage: true,
      appId: this.$route.query.appId,
      linkName: "",
      page: 1,
      perPage: 10,
      total: 0,
      tableData: [], //链接列表
      appDetail: {
        appName: "",
        appPackage: "",
        appIcon: "",
        id: "",
        appPackageMember: []
      },
    };
  },
  created() {
    this.queryLinkPage()
    this.queryIdentifyLastDetail()//获取应用详情
  },
  methods: {
    // 内容超出，显示文字提示内容
    onMouseOverAppName(str) {
      const tag = this.$refs[str];
      const parentWidth = tag.parentNode.offsetWidth;// 获取元素父级可视宽度要减去应用包名的长度
      const contentWidth = tag.offsetWidth; // 获取元素可视宽度
      this.isShowTooltipAppName = contentWidth <= parentWidth;
    },
    // 内容超出，显示文字提示内容
    onMouseOverAppPackage(str) {
      const tag = this.$refs[str];
      const parentWidth = tag.parentNode.offsetWidth;// 获取元素父级可视宽度要减去应用包名的长度
      const contentWidth = tag.offsetWidth; // 获取元素可视宽度
      this.isShowTooltipAppPackage = contentWidth <= parentWidth;
    },
    //打开冻结原因
    onFreezeShow(id) {
      this.$refs['freezeReason'].show(id)
    },
    //打开二维码弹窗
    onQRCode(appDetail, data) {
      this.$refs['QRCodeDialog'].open(appDetail, data)
    },
    //获取链接列表
    queryLinkPage() {
      this.$apis.consoleSever
          .queryLinkPage({
            appId: this.appId,
            linkName: this.linkName,
            page: this.page,
            perPage: this.perPage,
          }).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.total = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //获取应用信息
    queryIdentifyLastDetail() {
      this.$apis.consoleSever.queryDetail({
        id: this.appId,
      }).then(res => {
        if (res.code == 0) {
          this.appDetail = res.data;
          // 设置面包屑下拉选项
          this.$store.commit("breadcrumbStore/setKeyBreadcrumb", {
            key: this.$route.meta.key,
            name: this.appDetail.apkName,
            path: this.$route.fullPath,
            requestUrl: '/api/identifyApk/queryList'
          });
        }
      })
    },
    //创建链接
    onCreatedLink() {
      this.$router.push({
        path: '/console/appLink/link/form',
        query: {
          appId: this.$route.query.appId,
          appName: this.appDetail.appName,
          appPackage: this.appDetail.appPackage,
        }
      });
    },

    //编辑链接
    editLink(id) {
      this.$router.push({
        path: '/console/appLink/link/edit',
        query: {
          id: id,
          appName: this.appDetail.appName,
        }
      });
    },

    //链接数据
    onLinkData(id, appId) {
      this.$router.push({
        path: '/console/appLink/link/linkData',
        query: {
          appName: this.appDetail.appName,
          id: id,
          appId: appId,
        }
      });
    },

    //修改链接列表
    onModifyParamList(linkName, showState, id) {
      this.$router.push({
        path: '/console/appLink/link/modifyParamList',
        query: {
          appName: this.appDetail.appName,
          linkName,
          showState,
          id,
          appId: this.appId,
        }
      });
    },

    //撤回链接审核
    revokeLink(linkName, id) {
      this.$confirm(`<strong>确定撤回“${linkName}”的审核？</strong></br>撤回后你可重新编辑再提交审核`, '撤回审核', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        cancelButtonClass: 'cancelButton',
        confirmButtonClass: 'confirmButton',
        type: 'info ',
        center: true
      }).then(() => {
        this.$apis.consoleSever.editReviewStateCancel({
          id: id
        }).then(res => {
          if (res['code'] == 0) {
            this.search()
            this.$message({
              type: 'success',
              message: '撤回成功!'
            });
          }
        })
      })
    },

    //开启链接
    openLink(linkName, id) {
      this.$confirm(`<strong>确定开启“${linkName}”？</strong></br>开启后链接可正常访问`, '开启链接', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        cancelButtonClass: 'cancelButton',
        confirmButtonClass: 'confirmButton',
        type: 'info ',
        center: true
      }).then(() => {
        this.$apis.consoleSever.editStateEnable({
          id: id
        }).then(res => {
          if (res['code'] == 0) {
            this.search()
            this.$message({
              type: 'success',
              message: '开启成功!'
            });
          } else {
            this.$msgBox.alertMessageBox({
              title: "开启失败",
              content: res.message,
              btnText: '好的',
            })

          }
        })
      })
    },

    //关闭链接
    closeLink(linkName, id) {
      this.$confirm(`<strong>确定关闭“${linkName}”？</strong></br>关闭后访问该链接时将提示错误`, '关闭链接', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        cancelButtonClass: 'cancelButton',
        confirmButtonClass: 'confirmButton',
        type: 'info ',
        center: true
      }).then(() => {
        this.$apis.consoleSever.editStateDisable({
          id: id
        }).then(res => {
          if (res['code'] == 0) {
            this.search()
            this.$message({
              type: 'success',
              message: '关闭成功!'
            });
          } else {
            this.$message.error(res.message);
          }
        })
      })
    },
    //拷贝链接
    onCopy(data) {
      let oInput = document.createElement('input');
      oInput.value = data;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: '复制成功',
        type: 'success'
      });
      oInput.remove()
    },
    onEmpty() {
      if (this.linkName == "") {
        this.search();
      }
    },
    //搜索
    search() {
      this.page = 1;
      this.queryLinkPage();
    },
    //每页多少条
    sizeChange(val) {
      this.perPage = val;
      this.queryLinkPage();
    },
    //翻页
    currentChange(val) {
      this.page = val;
      this.queryLinkPage();
    },
    onShowError(item) {

      this.$alert(item.reviewRemark, {
        title: "审核未通过原因",
      }).then(_ => {
        done();
      })
    },
  },
};
</script>

<style scoped lang="scss">
.pageBox {
  padding: 20px;
  border-radius: 5px;
  min-height: calc(100% - 64px); //减底部(20px+ICP高度+20px)
  .pointer {
    cursor: pointer;

  }

  .content {
    min-height: 850px;
    background: #fff;
    box-shadow: $--background-shadow-base;
    overflow: hidden;

    .title {
      position: relative;
      display: flex;
      align-items: center;
      height: 100px;
      padding-left: 49px;
      font-size: 24px;
      line-height: 100%;
      color: rgba(201, 193, 153, 1);
      background: url(~@/assets/img/console/titleBg.jpg) no-repeat #28252c;
      background-position: 70% 0;

      &:after {
        content: "";
        position: absolute;
        top: 50%;
        left: 33px;
        width: 5px;
        height: 24px;
        transform: translateY(-50%);
        border-radius: 3px;
        background: #ded094;
      }
    }

    .ListBox {
      padding: 30px;
      min-height: 700px;

      .appInfohBox {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        .appInfo {
          display: flex;
          align-items: center;
          height: 100px;

          & > div {
            height: 100%;
            display: flex;
            flex-direction: column;

            p {
              margin-bottom: 8px;
              font-size: 16px;
              height: 30px;
              line-height: 30px;
            }
          }

          .border {
            width: 1px;
            height: 100px;
            margin: 0 20px;
            background: #ccc;
          }

          .imgBox {
            width: 100px;
            height: 100px;
            border-radius: 10px;
            margin-right: 19px;

            .img {
              width: 100%;
              height: 100%;
            }
          }

          .appName {
            max-width: 220px;
            font-size: 24px;
            color: #000000;
            font-weight: bold;
          }

          .freezeType {
            display: flex;
            flex-direction: column;
          }
        }
      }

      .tableBox {
        .el-icon-circle-check {
          font-size: 30px;
          color: green;
        }

        .el-icon-circle-close {
          font-size: 30px;
        }

        .el-icon-document-copy {
          font-size: 24px;
          margin-left: 8px;
        }
      }
    }
  }
}
</style>
<style scoped lang="scss">
.searchBtn {
  width: 100% !important;
  height: 48px;

  &:hover {
    opacity: 0.7;
  }

  /deep/ .el-input__inner {
    height: 48px;
  }

  .searchIcon {
    background: #fff;
  }
}

</style>
<style>
.el-message-box--center .el-message-box__message {
  font-size: 16px;
  color: #000000;
}

/* 确认窗 取消确认按钮位置更换 */
.el-message-box__wrapper .el-message-box__btns {
  display: flex;
  flex-flow: row-reverse;
  justify-content: center;
}

.cancelButton {
  width: 98px;
  margin: 0 10px;

}

.confirmButton {
  width: 98px;
  margin: 0 10px;
}
</style>
